import React from "react";
import { useParams } from "react-router-dom";
import { Spinner, SpinnerSize } from "@fluentui/react";
import SuitabilityTestConfirm from "@/components/SuitabilityTests/SuitabilityTestConfirm";
import { useContractStepGuard } from "@/screen/ContractManagement/hooks/useContractStepGuard";

/**
 * Confirmación/firma del test de idoneidad en el flujo de contrato.
 * Al firmar, vuelve al listado de idoneidad del plan.
 */
const ContractSuitabilityTestConfirmScreen: React.FC = () =>
{
    const { savingsPlanId, userIdentityId } = useParams<{savingsPlanId: string; userIdentityId: string}>();
    const planId = Number(savingsPlanId);
    const identityId = Number(userIdentityId);
    const guard = useContractStepGuard(planId, ["2.2.2", "2.4.3"]);

    if(guard.isChecking)
    {
        return(<Spinner size={SpinnerSize.large} style={{marginTop: "2rem"}} />);
    }

    return(
        <SuitabilityTestConfirm
            userIdentityId={identityId}
            returnRoute={`/contract/${planId}/suitabilityTest`}
            cancelRoute={`/contract/${planId}/suitabilityTest/test/${identityId}`}
        />
    );
};

export default ContractSuitabilityTestConfirmScreen;